var strVid = "";
var iTextCount = 0;
var strNote ="";
const storefronttoken = '50ddf974b05d6d34e1bcbd2f8ba2f14c';

//globalNote
const el = document.getElementById('CollectionInfo');
const strCollectionType = el?.dataset.handle || null;
if (window.innerWidth > 1200) 
  {
  var sideCart = document.getElementById("shopify-section-guttercrest-side-cart");
  sideCart.style.display = "flex";
}


console.log(strCollectionType);
$(document).on('click', '.gridAddToCart',async function (event)
{
    event.preventDefault();
    strVid = event.target.getAttribute("vid");
    console.log(event.target.parentElement.children);

    var strImgURL = event.target.parentElement.parentElement.parentElement.children[0].children[0].src;
    var strTitle = event.target.parentElement.parentElement.parentElement.children[0].children[1].children[0];
    var strSku = event.target.parentElement.parentElement.parentElement.children[0].children[1].children[1];

    var addedProductName = document.getElementById("addedProductName");
    var addedProductSku = document.getElementById("addedProductSku");
    var addedImg = document.getElementById("addedImg");
    var addedProductQty = document.getElementById("addedProductQty");

    console.log(globalToken);
    if (globalToken == "") 
    {
      await getCart();
    }
    iTextCount = parseInt(event.target.parentElement.children[1].value);
    var temp = strVid.split("gid://shopify/ProductVariant/"); 
    strVid = temp[1];

    addedProductName.innerText = strTitle.innerText
    addedProductSku.innerText = strSku.innerText
    addedProductQty.innerText = "X " +iTextCount
    addedImg.src = strImgURL

    if(milled.checked == true)
    {
        strNote = "Mill";
    }
    else
    {
        try
        {
          var activeItem = document.getElementsByClassName("activeFilterItem");
          strNote = activeItem[0].attributes.value.nodeValue;
          var strRalNote = activeItem[0].children[0].children[1].children[0].children[0].innerHTML
          strNote = strRalNote;
          if(marine.checked == true)
          {
            strNote = strNote + " Marine" 
          }

        }
        catch(e)
        {
          var preGrid = document.getElementById("activeColourDisplay");
          strNote = preGrid.className;
          if(strNote == "Mill" && milled.checked == false)
          {
              strNote ="";
          }
          if(marine.checked == true)
          {
            strNote = strNote + " Marine" 
          }
          else
          {
            strNote = strNote.replace(" Marine", "");
            strNote = strNote.replace(" MARINE", "");
          }
          if(strNote.includes("MARINE Marine"))
          {
            strNote = strNote.replace("MARINE Marine", "MARINE");

          }
          if(strNote.includes(" Marine Marine"))
          {
            strNote = strNote.replace("Marine Marine", "MARINE");
          }
        }
      
    }
    if(strNote == "none" || strNote == "None" || strNote == " Marine" || strNote == "Marine" || strNote == "none Marine" || strNote == "None Marine")
    {
      strNote = "";
    }
    if(strNote.length > 1 )
    {
      if(iTextCount > 0)
      {
        //GHEHG awaithere
        event.target.classList.add("spinnerLoad");
        event.target.classList.remove("gridAddToCart");
        await graphCart(strVid, iTextCount, 0);
        event.target.classList.remove("spinnerLoad");
        event.target.classList.add("gridAddToCart");
        //removerherge4
      }
      else
      {
        var modal = document.getElementById("myModal");

        var alertContent = document.getElementById("alertContent");
        alertContent.innerHTML = "<h3>Alert</h3><p>Please Add Quantity</p>"
        window.onclick = function(event) 
        {
          if (event.target == modal) {
            modal.style.display = "none";
          }
        }
        var span = document.getElementsByClassName("close")[0];
        modal.style.display = "block";

        span.onclick = function() 
        {
          modal.style.display = "none";
        }
      }
    }
    else
    {
        var modal = document.getElementById("myModal");
        var alertContent = document.getElementById("alertContent");
        alertContent.innerHTML = "<h3>Alert</h3><p>Please Select A finish</p>"
        window.onclick = function(event) 
        {
          if (event.target == modal) {
            modal.style.display = "none";
          }
        }
        var span = document.getElementsByClassName("close")[0];
        modal.style.display = "block";

        span.onclick = function() 
        {
          modal.style.display = "none";
        }
    }

    //await getCartGrid();
})

$(document).on('click', '#addAllGridOLD', async function (e)
{
  e.preventDefault();
  //Loop through
  console.log("Add All");

  var existingElements = document.querySelectorAll(".fixingCount");
  const productsWithQty = Array.from(existingElements).filter((inputCount) => inputCount.value > 0);
  if (globalToken == "") 
  {
    await getCart();
  }
  if(milled.checked == true)
  {
      strNote = "Mill";
  }
  else
  {
      try
      {
        var activeItem = document.getElementsByClassName("activeFilterItem");
        strNote = activeItem[0].attributes.value.nodeValue;
        var strRalNote = activeItem[0].children[0].children[1].children[0].children[0].innerHTML
        strNote = strRalNote;
        if(marine.checked == true)
        {
          strNote = strNote + " Marine" 
        }

      }
      catch(e)
      {
        var preGrid = document.getElementById("activeColourDisplay");
        strNote = preGrid.className;
        if(strNote == "Mill" && milled.checked == false)
        {
            strNote ="";
        }
        if(marine.checked == true)
        {
          strNote = strNote + " Marine" 
        }
        else
        {
          strNote = strNote.replace(" Marine", "");
          strNote = strNote.replace(" MARINE", "");
        }
        if(strNote.includes("MARINE Marine"))
        {
          strNote = strNote.replace("MARINE Marine", "MARINE");

        }
        if(strNote.includes(" Marine Marine"))
        {
          strNote = strNote.replace("Marine Marine", "MARINE");
        }
      }
    
  }
  var items = [];


  if(strNote == "none" || strNote == "None" || strNote == " Marine" || strNote == "Marine" || strNote == "none Marine" || strNote == "None Marine")
  {
    strNote = "";
  }
  if(strNote.length > 1 )
  {
    var cartsize = document.getElementsByClassName("sidebar-cart-item")
    if(cartsize.length == 0 )
      {
          try 
          {
              $.ajax(
              {
                  url: "https://rocking-rhino-dev.myshopify.com/api/2025-01/graphql.json",
                  contentType: "application/json",
                  type:'POST',
                  async : false,
                  headers:{
                      "X-Shopify-Storefront-Access-Token": storefronttoken,
                      "Content-Type": "application/json"
                  },
                  data: JSON.stringify({
                  query:`mutation
                  {
                      cartNoteUpdate(cartId: "gid://shopify/Cart/${globalToken}", 
                      note: "${strNote}") 
                      {
                          cart 
                          {
                              note
                          }
                          userErrors 
                          {
                              field
                              message
                          }
                          warnings 
                          {
                              code
                          }
                      }
                  }`
                  }),
              }).done(function (response2) 
              {  
                  console.log(response2.data.cartNoteUpdate.cart.note);
                  var cartNote = response2.data.cartNoteUpdate.cart.note;
                  changeItemGrid();
                  
              });
              
          }
          catch (error) {
              
          }
      }

      async function processArray(array) 
      {
        for (const inputElement of array) 
        {
          var strVid = inputElement.attributes.vid.value;
          strVid = strVid.replace('gid://shopify/ProductVariant/', '');

          await graphCart(strVid, inputElement.value, 1);
          inputElement.value = 0;
        }
      }
        
      strNote = strNote.toUpperCase();
      if(strNote == globalNote || globalNote == "" || globalNote == null)
      {
        if( globalNote == "" || globalNote == null)
        {
          var cartColourIcon = document.getElementById("activeColourDisplayCart");
          var strTempNote = strNote;
          strTempNote = strTempNote = strTempNote.replace(" Marine", "");
          strTempNote = strTempNote.replace(" MARINE", "");
          strTempNote = strTempNote.replace(" ", "_");
          if(marine.checked == true)
          {
            strTempNote = strTempNote + " Marine" 
          }
          cartColourIcon.className = strTempNote;
        }
        globalNote = strNote.toUpperCase();
        e.target.classList.add("spinnerLoad");
        await processArray(productsWithQty);
        e.target.classList.remove("spinnerLoad");
        renderCart();
      }
      else
      {
        var tempStr = globalNote;
        tempStr = tempStr.replaceAll("_"," ");
        
        var modal = document.getElementById("myModal");
        var alertContent = document.getElementById("alertContent");
        alertContent.innerHTML = "<h3>Alert</h3><p>Select " + tempStr + " as Finish or clear cart</p>"
        window.onclick = function(event) 
        {
          if (event.target == modal) {
            modal.style.display = "none";
          }
        }
        var span = document.getElementsByClassName("close")[0];
        modal.style.display = "block";

        span.onclick = function() 
        {
          modal.style.display = "none";
        }
        reject();
      }

  }
  else
  {
    var modal = document.getElementById("myModal");
    var alertContent = document.getElementById("alertContent");
    alertContent.innerHTML = "<h3>Alert</h3><p>Please Select A finish</p>"
    window.onclick = function(event) 
    {
      if (event.target == modal) {
        modal.style.display = "none";
      }
    }
    var span = document.getElementsByClassName("close")[0];
    modal.style.display = "block";

    span.onclick = function() 
    {
      modal.style.display = "none";
    }
    
  }


});


async function graphCart(variantID, iAddToCart, iChangeItem, angleValue = null, wallWidth = null, faceSize = null, projectionLength = null)
{
  return new Promise(function(resolve, reject) 
  {
    var items = {
      id: variantID,
      quantity: iAddToCart
    }

    if (!items.properties) {
      items.properties = {};
    }
    

    if (projectionLength !== null) {
      items.properties.Projection = projectionLength + "mm";
    }
    
    if (angleValue !== null) {
      items.properties.Angle = angleValue + "°";
    }

    if (wallWidth !== null) {
      items.properties.WallWidth = wallWidth + "mm";
    }
    
    if (faceSize !== null) {
      items.properties.FaceSize = faceSize + "mm";
    }


    function changeItem() {
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: items,
        success: addToCartOk,
        error: function(XMLHttpRequest, textStatus) {
          console.log(XMLHttpRequest, textStatus);
          reject(XMLHttpRequest);
        }
      });
    }

    function addToCartOk(product) 
    {
      getCart2();
      function getCart2() 
      {
        $.ajax({
          type: 'GET', 
          url: '/cart.js',
          success: getCartList2,
          error: function(XMLHttpRequest, textStatus) {
            console.log(XMLHttpRequest, textStatus);
          }
        });
      }
    
      function getCartList2(CartList)
      {
        iCartTotal = 0;
        var objTemp = JSON.parse(CartList);
        globalToken = objTemp.token;

        try 
        {
            $.ajax(
            {
                url: "https://rocking-rhino-dev.myshopify.com/api/2025-01/graphql.json",
                contentType: "application/json",
                type:'POST',
                async : false,
                headers:{
                    "X-Shopify-Storefront-Access-Token": storefronttoken,
                    "Content-Type": "application/json"
                },
                data: JSON.stringify({
                query:`mutation
                {
                  cartNoteUpdate(cartId: "gid://shopify/Cart/${globalToken}", 
                  note: "${strNote}") 
                  {
                    cart 
                    {
                      note
                    }
                    userErrors 
                    {
                      field
                      message
                    }
                    warnings 
                    {
                      code
                    }
                  }
                }`
                }),
            }).done(function (response2) 
            {  
              console.log(response2.data.cartNoteUpdate.cart.note);                
            });
            
        }
        catch (error) {
          reject(error)
        }


        var obj = JSON.parse(CartList);
        var incoming = obj.items;
        

        var arrayLength = incoming.length;
        for (var i = 0; i < arrayLength; i++) 
        {
            iCartTotal = iCartTotal + parseFloat(incoming[i].line_price);
        }

        var iCartTotalTemp  = iCartTotal;

        var cartCountElement = document.getElementsByClassName("count-cart-sidebar"); // by class JS version
        cartCountElement[0].innerText= "("+ incoming.item_count+")";
      
        //Here I Rerender cart
    
        var emptycart =  document.getElementById("emptycartfiller");
        if (emptycart) 
        {
          document.getElementById("emptycartfiller").remove();
        }
                
        var cartitemlink = document.createElement('div');
        cartitemlink.classList.add("sidebar-cart-item");
        
        const price =  (product.final_price/100);
    
        function formatMoney(number) 
        {
            number = number.toFixed(2);
            const valueArray = number.split(".");
            var strNumber = '<span class="poundSignSide">£ </span><span class="poundActualSide">';
            strNumber = strNumber.concat(valueArray[0]);
            strNumber = strNumber.concat('</span> <span class="penceSide">');
            strNumber = strNumber.concat(valueArray[1]);
            strNumber = strNumber.concat("</span>");
            return strNumber;
        }
        cartitemlink.id = product.id;
        
        //Look for item with the id remove it and repopulate 
        try 
        {
          const elem = document.getElementById(product.id).remove();
        } 
        catch (error) 
        {}

        var angleHtml = "";
        var wallwidthHtml = "";
        var faceSizeHtml = "";
        var projectionSizeHtml = "";

        if (product.properties && product.properties.Angle) {
          angleHtml = '<p class="sidebar-line-property">Angle: ' + product.properties.Angle + '</p>';
        }

        if (product.properties && product.properties["WallWidth"]) {
          wallwidthHtml = '<p class="sidebar-line-property">Wall Width: ' + product.properties["WallWidth"] + '</p>';
        }

        if (product.properties && product.properties["FaceSize"]) {
          faceSizeHtml = '<p class="sidebar-line-property">Face Size: ' + product.properties["FaceSize"] + '</p>';
        }

        if (product.properties && product.properties["Projection"]) {
          projectionSizeHtml = '<p class="sidebar-line-property">Projection: ' + product.properties["Projection"] + '</p>';
        }

        cartitemlink.innerHTML ='<a class="cart-item-link"  href="'+ product.url
        +'"><img height="100" width="100" class="sidebar-cart-img" src="' + product.image 
        +'"><div class="sidebar-title-price-container"><span class="name"><p class="name-text">' +product.product_title 
        +'</p></span>'+ angleHtml + wallwidthHtml + faceSizeHtml + projectionSizeHtml+'<div style="margin-top: -10px; margin-bottom: 10px;">'+ formatMoney(price) 
        +'<span class="unitPrice"> x '+ product.quantity
        +'</span></div></div></a><span class="close-btn" js-preworn-close-modal=""><svg qty="'+product.quantity+'" vid="'+ product.key +
        '"class="remove-item-sidebar" width="25" viewBox="0 0 10 10"><path qty="'+product.quantity+'" vid="'+ product.key +'" d="M9.677 8.118a1.102 1.102 0 11-1.559 1.56L5 6.558 1.882 9.677a1.102 1.102 0 11-1.56-1.559L3.442 5 .323 1.882A1.102 1.102 0 111.882.322L5 3.442 8.118.323a1.102 1.102 0 111.56 1.559L6.558 5l3.118 3.118z" fill="red" fill-rule="nonzero"></path></svg></span></div>';
    
        var iCartTotalTemp  = iCartTotal/100;
        // var cartSideBarPrice = document.getElementById('cartSideBarPrice');
        var priceHTML = formatMoney(iCartTotalTemp);
        //cartSideBarPrice.innerHTML = priceHTML;
    
        var cartdiv = document.getElementsByClassName('guttercrest-flex-container')[0];
        cartdiv.appendChild(cartitemlink);
        
        console.log(document.getElementsByClassName('cart-count-bubble').length);
        if(document.getElementsByClassName('cart-count-bubble').length == 0)
        {
            var cartcountdiv  = document.createElement('div');
            cartcountdiv.classList.add("cart-count-bubble");
            cartcountdiv.innerHTML ='<span aria-hidden="true"></span><span class="visually-hidden"></span>';
            
            document.getElementById("cart-icon-bubble").appendChild(cartcountdiv);
        }

        //UpdateCartnot

        jQuery.getJSON('/cart.js', function (cart, textStatus) 
        {
            //the cart info is in the callback. the item_count is available as part of the callback
            //below I set my cartcount div with the current cart item_count
            var carttext="("+cart.item_count +")";
            jQuery(".cart-count-bubble").text(carttext);
            jQuery(".count-cart-sidebar").text(carttext);
        });  

        resolve()
      }
    }
    if(globalToken == "" || globalToken == null)
    {
      changeItem();
    }
    else
    {
      if( globalNote == "" || globalNote == null)
        {
          var cartColourIcon = document.getElementById("activeColourDisplayCart");
          var strTempNote = strNote;
          strTempNote = strTempNote.replace(" Marine", "");
          strTempNote = strTempNote.replace(" MARINE", "");
          strTempNote = strTempNote.replace(" ", "_");

          cartColourIcon.className = strTempNote;
          if(marine.checked == true)
          {
            strTempNote = strTempNote + " Marine" 
          }
          cartColourIcon.innerText  = strTempNote;
        }
      try 
      {
        $.ajax({
          url: "https://rocking-rhino-dev.myshopify.com/api/2025-01/graphql.json",
          contentType: "application/json",
          type:'POST',
          async : false,
          headers:{
              "X-Shopify-Storefront-Access-Token": storefronttoken,
              "Content-Type": "application/json"
          },
          data: JSON.stringify({
          query:`query
          {
              cart(id: "gid://shopify/Cart/${globalToken}") 
              {
                  attributes
                  {
                    key
                    value
                  }
                  note
                  totalQuantity
              }
          }`
          }),
          }).done(async function (response) 
          {  
            try 
            {
              if(response.data.cart == null)
              {
                var cartNote = "";
                var cartSize = "";
                var cartAttributes = "";
                var cartType = {};
                cartType.value = strCollectionType;
              }
              else
              {
                console.log(response.data.cart.note);
                var cartNote = response.data.cart.note;
                var cartSize = response.data.cart.totalQuantity;
                var cartAttributes = response.data.cart.attributes;
                var cartType = cartAttributes.find(o => o.key === "cartType");
              }
              postCart();
            } 
            catch (error) 
            {
              console.log(error);
              var cartNote = "";
              var cartSize = 0;
            }
            function changeItemGrid() {
              var addedModal = document.getElementById("addedModal");
              addedModal.style.display = "block";
            
              var s = addedModal.style;
              s.opacity = 1;
              (function fade() {
                (s.opacity -= .1) < 0 ? s.display = "none" : setTimeout(fade, 240);
              })();
            
              $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                dataType: 'json',
                data: items,
                success: addToCartGridOk,
                error: function(XMLHttpRequest, textStatus) {
                  console.log(XMLHttpRequest, textStatus);
                  reject(XMLHttpRequest);
                }
              });
            }

            function addToCartGridOk(product) 
            {
              try 
              {
                $.ajax({
                  url: "https://rocking-rhino-dev.myshopify.com/api/2025-01/graphql.json",
                  contentType: "application/json",
                  type:'POST',
                  async : false,
                  headers:{
                      "X-Shopify-Storefront-Access-Token": token,
                      "Content-Type": "application/json"
                  },
                  data: JSON.stringify({
                  query:`query
                  {
                      cart(id: "gid://shopify/Cart/${globalToken}") 
                      {
                      cost
                      {
                        totalAmount
                        {
                        amount 
                        }
                      }
                      totalQuantity
                      lines(first:250) {
                        edges {
                          node {
                            id
                            quantity
                            merchandise {
                              ... on ProductVariant {
                                id
                                  price
                                  {
                                      amount
                                  }
                                product
                                {
                                  tags
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }`
                  }),
                  }).done(async function (response) 
                  {  
                      getCartList2(response);
                  })
              }
              catch(e)
              {
                console.log(e);
                console.log("In error need to handle");
              }


            
              function getCartList2(CartList)
              {
                iCartTotal = 0;
                try {
                  var incoming = CartList.data.cart.lines.edges;
                  var totalAmount = CartList.data.cart.cost.totalAmount.amount;
                } catch (error) {
                  var incoming = [];
                  var totalAmount = 0;
                  globalToken = "";
                }

  
                var arrayLength = incoming.length;
                for (var i = 0; i < arrayLength; i++) 
                {
                    iCartTotal = iCartTotal + parseFloat(incoming[i].node.merchandise.price.amount);
                }
        
                var iCartTotalTemp  = iCartTotal/100;
        
                var cartCountElement = document.getElementsByClassName("count-cart-sidebar"); // by class JS version
                cartCountElement[0].innerText= "("+ incoming.item_count+")";

                
                var vatAmount = (totalAmount*.2).toFixed(2);
                var PriceDiv = document.getElementById("sidecartprice");
                var subtotal = (totalAmount-vatAmount).toFixed(2);
                PriceDiv.innerHTML = `
                <div class="cartfooterprice"><span>VAT</span><span>£${vatAmount}</span></div>
                <div class="cartfooterprice"><span>subtotal</span><span>£${subtotal}</span></div>
                <div class="cartfooterprice"><span>Total (inc VAT)</span><span>£${totalAmount}</span></div>
                `;
                //Here I Rerender cart
            
                var emptycart =  document.getElementById("emptycartfiller");
                if (emptycart) 
                {
                    document.getElementById("emptycartfiller").remove();
                }
                        
                var cartitemlink = document.createElement('div');
                cartitemlink.classList.add("sidebar-cart-item");
                
                var price =  (product.final_price/100);
            
                function formatMoney(number) 
                {
                    number = number.toFixed(2);
                    const valueArray = number.split(".");
                    var strNumber = '<span class="poundSignSide">£ </span><span class="poundActualSide">';
                    strNumber = strNumber.concat(valueArray[0]);
                    strNumber = strNumber.concat('</span> <span class="penceSide">');
                    strNumber = strNumber.concat(valueArray[1]);
                    strNumber = strNumber.concat("</span>");
                    return strNumber;
                }
                if(product.id == null)
                {
                  // variantID
                  let variantIDTemp = parseInt(variantID, 10); // 10 = decimal
                  var tempproduct = product.items.filter(u => u.id === variantIDTemp);
                  product = tempproduct[0];
                  price =  (product.final_price/100);
                }
                cartitemlink.id = product.key;
                //Look for item with the id remove it and repopulate 
                try 
                {
                  const elem = document.getElementById(product.key);
                  if (elem) elem.remove();
                } 
                catch (error) 
                {
                    
                }
                var angleHtml = "";
                var projectionHtml = "";
                var wallwidthHtml = "";
                var faceSizeHtml = "";

                if (product.properties && product.properties.Angle) {
                  angleHtml = '<p class="sidebar-line-property">Angle: ' + product.properties.Angle + '</p>';
                }
      
                if (product.properties && product.properties["WallWidth"]) {
                  wallwidthHtml = '<p class="sidebar-line-property">Wall Width: ' + product.properties["WallWidth"] + '</p>';
                }

                if (product.properties && product.properties["FaceSize"]) {
                  faceSizeHtml = '<p class="sidebar-line-property">Face Size: ' + product.properties["FaceSize"] + '</p>';
                }
    
                if (product.properties && product.properties.Projection) {
                  projectionHtml = '<p class="sidebar-line-property">Projection: ' + product.properties.Projection + '</p>';
                }
      

                cartitemlink.setAttribute('data-angle', product.properties?.Angle || '');
                cartitemlink.setAttribute('data-projection', product.properties?.Projection || '');
                cartitemlink.setAttribute('data-wallwidth', product.properties?.WallWidth || '');
                cartitemlink.setAttribute('data-facesize', product.properties?.FaceSize || '');
                
                try 
                {
                  var oldVariantId = String(product.key).split(':')[0];
                
                  var newAngle = product.properties?.Angle || '';
                  var newWallWidth = product.properties?.WallWidth || '';
                  var newFaceSize = product.properties?.FaceSize || '';
                  var newProjection = product.properties?.Projection || '';

                  document.querySelectorAll('.sidebar-cart-item[id^="' + oldVariantId + ':"]').forEach(function(elem) {
                    var sameAngle = (elem.getAttribute('data-angle') || '') === newAngle;
                    var sameProjection = (elem.getAttribute('data-projection') || '') === newProjection;
                    var sameWallWidth = (elem.getAttribute('data-wallwidth') || '') === newWallWidth;
                    var sameFaceSize = (elem.getAttribute('data-facesize') || '') === newFaceSize;
                
                    if (sameAngle && sameWallWidth && sameFaceSize && sameProjection) {
                      elem.remove();
                    }
                  });
                } 
                catch (error) 
                {
                }


                cartitemlink.innerHTML ='<a class="cart-item-link"  href="'+ product.url
                +'"><img height="100" width="100" class="sidebar-cart-img" src="' + product.image 
                +'" /><div class="sidebar-title-price-container"><span class="name"><p class="name-text">' +product.product_title 
                +'</p></span>'+ angleHtml + projectionHtml + wallwidthHtml + faceSizeHtml +'<div style="margin-top: -10px; margin-bottom: 10px;">'+ formatMoney(price) 
                +'<span style="font-weight: bold; font-size: 3rem; position: relative; margin-right: 1px;" class="unitPrice"> x '+ product.quantity
                +'</span></div></div></a><span class="close-btn" js-preworn-close-modal=""><svg qty="'+product.quantity+'" vid="'+ product.key +
                '"class="remove-item-sidebar" width="25" viewBox="0 0 10 10"><path qty="'+product.quantity+'" vid="'+ product.key +'" d="M9.677 8.118a1.102 1.102 0 11-1.559 1.56L5 6.558 1.882 9.677a1.102 1.102 0 11-1.56-1.559L3.442 5 .323 1.882A1.102 1.102 0 111.882.322L5 3.442 8.118.323a1.102 1.102 0 111.56 1.559L6.558 5l3.118 3.118z" fill="red" fill-rule="nonzero"></path></svg></span></div>';
            
                var iCartTotalTemp  = iCartTotal/100;

                // var cartSideBarPrice = document.getElementById('cartSideBarPrice');
                    
                var priceHTML = formatMoney(iCartTotalTemp);
                //cartSideBarPrice.innerHTML = priceHTML;
            
                var cartdiv = document.getElementsByClassName('guttercrest-flex-container')[0];
                cartdiv.appendChild(cartitemlink);
                refreshVariantRows(product.key.split(':')[0]);
                
                console.log(document.getElementsByClassName('icon-cart-empty').length);
                if(document.getElementsByClassName('cart-count-bubble').length == 0)
                {
                    var cartcountdiv  = document.createElement('div');
                    cartcountdiv.classList.add("cart-count-bubble");
                    cartcountdiv.innerHTML ='<span aria-hidden="true"></span><span class="visually-hidden"></span>';
                    
                    document.getElementById("cart-icon-bubble").appendChild(cartcountdiv);
                }

                jQuery.getJSON('/cart.js', function (cart, textStatus) 
                {
                    //the cart info is in the callback. the item_count is available as part of the callback
                    //below I set my cartcount div with the current cart item_count
                    var carttext="("+cart.item_count +")";
                    jQuery(".cart-count-bubble").text(carttext);
                    jQuery(".count-cart-sidebar").text(carttext);
                });
                cartFixingOnAdd();
                const el = document.querySelector(".guttercrest-sidebar-cart-contents");
                if (el) {
                  el.scrollTop = el.scrollHeight; // jumps to bottom
                }
                resolve();
              }
            }
            function getCurrentCollectionHandleGrid() 
            {
              // Prefer your global
              if (window.pageContext?.collection?.handle) return window.pageContext.collection.handle;
            
              // Fallback to DOM
              const el = document.getElementById("CollectionInfo");
              return el?.dataset?.handle || null;
            }
            
            async function postCart()
            {
              var collectionHandle =await getCurrentCollectionHandleGrid();

              cartSize = await setCartCount();

              console.log("cartSize before exception:", cartSize);

              if(collectionHandle == "fixings") ///Here I need to add another collection cas-iron-fixings or make another if statement
              {
                const cartFixingCastIron = await fetch('/cart.js').then(r => r.json());

                const cartTypeAttributeFixingCastIron = cartFixingCastIron.attributes?.cartType || "";
                const cartIsEmpty = cartFixingCastIron.items.length === 0;

                if (strCollectionType == "fixings") 
                {
                  if (cartTypeAttributeFixingCastIron !== "cast-iron" && cartFixingCastIron.items.length !== 0) 
                  {
                    renderError(cartNote);
                    return;
                  }
                }
                if (cartTypeAttributeFixingCastIron == "cast-iron") 
                {
                  if (strCollectionType !== "fixings" && cartFixingCastIron.items.length !== 0) 
                  {
                    renderError(cartNote);

                    return;
                  }
                }

                setCartType("cartType", "cast-iron");
                cartSize = 1;
                changeItemGrid();
                resolve();
              }
              else
              {
                const exceptionProductId = "51172588650838"; //Touch up paint 51172588650838
                if(collectionHandle == "fixing-sundries" && variantID != exceptionProductId) ///Here I need to add another collection cas-iron-fixings or make another if statement
                {
                  const cartFixing = await fetch('/cart.js').then(r => r.json());
                  const cartTypeAttributeFixing = cartFixing.attributes?.cartType || "";
                  
                  if (strCollectionType == "cast-iron") 
                  {
                    if (cartTypeAttributeFixing !== "cast-iron") 
                    {
                      renderError(cartNote);

                      return;
                    }
                  }
                  if (cartTypeAttributeFixing == "cast-iron") 
                  {
                    if (strCollectionType !== "cast-iron") 
                    {
                      renderError(cartNote);

                      return;
                    }
                  }
                  //Need to check if its a Cast iron
                  setCartType("cartType","Aluminium");
                  cartSize = 1;
                  changeItemGrid();
                  resolve();
                }
                else
                {
                  if(cartSize == 0 )
                  {
                    let text = "Confirm Finish: " + strNote;
                    
                    if(strNote == "Mill Marine")
                    {
                      var modal = document.getElementById("myModal");
                      var alertContent = document.getElementById("alertContent");
                      alertContent.innerHTML = "<h3>Alert</h3><p>Please Select A finish</p>"
                      window.onclick = function(event) 
                      {
                        if (event.target == modal) {
                          modal.style.display = "none";
                        }
                      }
                      var span = document.getElementsByClassName("close")[0];
                      modal.style.display = "block";
              
                      span.onclick = function() 
                      {
                        modal.style.display = "none";
                      }
                    }
                    else
                    {
                      if(strNote == "HIGH-GLOSS-BLACK" && strCollectionType !== "cast-iron")
                      {
                        var modal = document.getElementById("myModal");
                        var alertContent = document.getElementById("alertContent");
                        alertContent.innerHTML = "<h3>Alert</h3><p>Colour not available please select colour</p>"
                        window.onclick = function(event) 
                        {
                          if (event.target == modal) {
                            modal.style.display = "none";
                          }
                        }
                        var span = document.getElementsByClassName("close")[0];
                        modal.style.display = "block";
                
                        span.onclick = function() 
                        {
                          modal.style.display = "none";
                        }
              
                        var strFindElement = '[evid="gid://shopify/ProductVariant/' + variantID + '"]';
                        var element = document.querySelector(strFindElement);
                        
                        if (element) {
                          element.classList.remove("spinnerLoad");
                          element.classList.add("gridAddToCart");
                        }
                        
                        resolve();
                        
                      }
                      else
                      {
                        const cart = await fetch('/cart.js').then(r => r.json());
                        const cartTypeAttribute = cart.attributes?.cartType || "";

                        if (strCollectionType == "cast-iron") 
                        {
                          if (cartTypeAttribute !== "cast-iron") 
                          {
                            renderError(cartNote);
                            resolve();
                            return;
                          }
                        }
                        if (cartTypeAttribute == "cast-iron") 
                        {
                          if (strCollectionType !== "cast-iron") 
                          {
                            renderError(cartNote);
                            resolve();
                            return;
                          }
                        }

                        
                        if (confirm(text) == true) 
                        {
                          localStorage.clear();
                          //Here reinitalise the cart..
                          //So Add items to cart then get the cart token and set the cart note
                          try 
                          {
                            
                            globalToken = cart.token;
    
                            $.ajax(
                            {
                                url: "https://rocking-rhino-dev.myshopify.com/api/2025-01/graphql.json",
                                contentType: "application/json",
                                type:'POST',
                                async : false,
                                headers:{
                                    "X-Shopify-Storefront-Access-Token": storefronttoken,
                                    "Content-Type": "application/json"
                                },
                                data: JSON.stringify({
                                query:`mutation
                                {
                                    cartNoteUpdate(cartId: "gid://shopify/Cart/${globalToken}", 
                                    note: "${strNote}") 
                                    {
                                        cart 
                                        {
                                            note
                                        }
                                        userErrors 
                                        {
                                            field
                                            message
                                        }
                                        warnings 
                                        {
                                            code
                                        }
                                    }
                                }`
                                }),
                            }).done(function (response2) 
                            {  
                                console.log(response2.data.cartNoteUpdate.cart.note);
                                var cartNote = response2.data.cartNoteUpdate.cart.note;
                                  changeItemGrid();
                            });
                          }
                          catch (error) {
                            reject(error)
                          }
                          
                            var attribute = [{
                              key: "cartType",
                              value: strCollectionType
                            }];

                            setCartType("cartType",strCollectionType);
                            //document.getElementById("cartsidebarTitleText").innerText = 'My Order';
                            strType = strCollectionType;
                        } 
                        else 
                        {
                          var strFindElement = '[evid="gid://shopify/ProductVariant/' + variantID + '"]';
                          var element = document.querySelector(strFindElement);
                          
                          if (element) {
                            element.classList.remove("spinnerLoad");
                            element.classList.add("gridAddToCart");
                          }
                          resolve();
                        }
                      }
                    }
    
                  }
                  else
                  {
                      strNote = strNote.replace("_", " ");
                      if(strNote.toUpperCase() == cartNote.toUpperCase())
                      {
    
                        if(cartType)
                        {
                          if(cartType.value == "cast-iron")
                          {
                            if(strCollectionType == "cast-iron")
                            {
                              changeItemGrid();
                        
                            }
                            else
                            {
                              renderError(cartNote)
                            }
                          }
                          else
                          {
                            if(strCollectionType == "cast-iron")
                            {
                              renderError(cartNote)
                            }
                            else
                            {
                              changeItemGrid();
                            }
                            
                          }
                        }
                        else
                        {
                          if(strCollectionType == "cast-iron")
                          {
                            cartType ={};
                            cartType.value = "cast-iron";
                            changeItemGrid();
                          }
                          else
                          {   
                            cartType ={};
                            cartType.value = strCollectionType;
                            changeItemGrid();
                          }
                        }
                      }
                      else
                      {
                          var tempStr = cartNote;
                          tempStr = tempStr.replaceAll("_"," ");
    
                          var modal = document.getElementById("myModal");
                          var alertContent = document.getElementById("alertContent");
                          alertContent.innerHTML = "<h3>Alert</h3><p>Select " + tempStr + " as Finish or clear cart</p>"
                          window.onclick = function(event) 
                          {
                            if (event.target == modal) {
                              modal.style.display = "none";
                            }
                          }
                          var span = document.getElementsByClassName("close")[0];
                          modal.style.display = "block";
                  
                          span.onclick = function() 
                          {
                            modal.style.display = "none";
                          }
                
                          var strFindElement ='[evid="gid://shopify/ProductVariant/'+variantID+'"]';
                          var element = document.querySelector(strFindElement);
                          console.log(element);
                          element.classList.remove("spinnerLoad");
                          element.classList.add("gridAddToCart");
                          
                          resolve();
                      }
                  }
                }
              }
            }
          });

      } 
      catch (error) 
      {
        console.log(error);
        reject(error)
      }

    }

  });

  function renderError(strErrorNote)
  {
    var tempStr = strErrorNote;
    tempStr = tempStr.replaceAll("_"," ");

    var modal = document.getElementById("myModal");
    var alertContent = document.getElementById("alertContent");
    alertContent.innerHTML = "<h3>Alert</h3><p>Can't Deliver Aluminium & Cast Iron in the same order</p>"
    window.onclick = function(event) 
    {
      if (event.target == modal) {
        modal.style.display = "none";
      }
    }
    var span = document.getElementsByClassName("close")[0];
    modal.style.display = "block";

    span.onclick = function() 
    {
      modal.style.display = "none";
    }

    var strFindElement = '[evid="gid://shopify/ProductVariant/' + variantID + '"]';
    var element = document.querySelector(strFindElement);
    
    if (element) {
      element.classList.remove("spinnerLoad");
      element.classList.add("gridAddToCart");
    }
  
  }
}   


async function setCartType(key, value) 
{
  const cartId = `gid://shopify/Cart/${globalToken}`;

  const getCartQuery = `
    query GetCart($cartId: ID!) {
      cart(id: $cartId) {
        attributes {
          key
          value
        }
      }
    }
  `;

  const cartRes = await fetch("/api/2025-01/graphql.json", {
    method: "POST",
    headers: {
      "X-Shopify-Storefront-Access-Token": storefronttoken,
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      query: getCartQuery,
      variables: { cartId }
    })
  });

  const cartJson = await cartRes.json();

  const existingAttributes = cartJson.data.cart.attributes || [];

  const mergedAttributes = [
    ...existingAttributes.filter(attr => attr.key !== key),
    {
      key: key,
      value: value
    }
  ];

  const updateQuery = `
    mutation CartAttributesUpdate($cartId: ID!, $attributes: [AttributeInput!]!) {
      cartAttributesUpdate(cartId: $cartId, attributes: $attributes) {
        cart {
          attributes {
            key
            value
          }
          note
        }
        userErrors {
          field
          message
        }
        warnings {
          code
        }
      }
    }
  `;

  const updateRes = await fetch("/api/2025-01/graphql.json", {
    method: "POST",
    headers: {
      "X-Shopify-Storefront-Access-Token": storefronttoken,
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      query: updateQuery,
      variables: {
        cartId,
        attributes: mergedAttributes
      }
    })
  });

  const updateJson = await updateRes.json();

  console.log(updateJson.data.cartAttributesUpdate.cart.attributes);

  return updateJson.data.cartAttributesUpdate.cart.attributes;
}


function renderCart() 
{
  getCartRender();
  
  function getCartRender() 
  {
    $.ajax({
      type: 'GET', 
      url: '/cart.js',
      success: getCartListRender,
      error: function(XMLHttpRequest, textStatus) {
        console.log(XMLHttpRequest, textStatus);
      }
    });
  }

  function getCartListRender(CartList)
  {
    $(".sidebar-cart-item").remove();
    iCartTotal = 0;
    var obj = JSON.parse(CartList);
    var incoming = obj.items;

    var strCartType = "";
    try {
      strCartType = obj.attributes.cartType;
    } catch (error) {
      
    }


    var arrayLength = incoming.length;
    for (var i = 0; i < arrayLength; i++) 
    {
        iCartTotal = iCartTotal + parseFloat(incoming[i].line_price);
    }


    var cartCountElement = document.getElementsByClassName("count-cart-sidebar"); // by class JS version
    cartCountElement[0].innerText= "("+ incoming.item_count+")";
    var cartCountElement = document.getElementsByClassName("count-cart-sidebar"); // by class JS version
    cartCountElement[0].innerText= "("+ incoming.item_count+")";
    
    var emptycart =  document.getElementById("emptycartfiller");
    if (emptycart) 
    {
        document.getElementById("emptycartfiller").remove();
    }
    var cartdiv = document.getElementsByClassName('guttercrest-flex-container')[0];

    function formatMoney(number) 
    {
        number = number.toFixed(2);
        const valueArray = number.split(".");
        var strNumber = '<span class="poundSignSide">£ </span><span class="poundActualSide">';
        strNumber = strNumber.concat(valueArray[0]);
        strNumber = strNumber.concat('</span> <span class="penceSide">');
        strNumber = strNumber.concat(valueArray[1]);
        strNumber = strNumber.concat("</span>");
        return strNumber;
    }

    for (var k = 0; k < arrayLength; k++) 
    {
        var cartitemlink = document.createElement('div');
        cartitemlink.classList.add("sidebar-cart-item");
        
        const price =  (incoming[k].final_price/100);

        var angleHtml = "";
        var projectionHtml = "";
        var wallwidthHtml = "";
        var faceSizeHtml = "";

        cartitemlink.id = incoming[k].key;
        if (product.properties && product.properties.Angle) {
          angleHtml = '<p class="sidebar-line-property">Angle: ' + product.properties.Angle + '</p>';
        }
        if (product.properties && product.properties.Projection) {
          projectionHtml = '<p class="sidebar-line-property">Projection: ' + product.properties.Projection + '</p>';
        }

        if (incoming[k].properties && incoming[k].properties["WallWidth"]) {
          wallwidthHtml = '<p class="sidebar-line-property">Wall Width: ' + incoming[k].properties["WallWidth"] + '</p>';
        }

        if (product.properties && product.properties["FaceSize"]) {
          faceSizeHtml = '<p class="sidebar-line-property">Face Size: ' + product.properties["FaceSize"] + '</p>';
        }

        cartitemlink.innerHTML ='<a class="cart-item-link"  href="'+ incoming[k].url 
        +'"><img height="100" width="100" class="sidebar-cart-img" src="' + incoming[k].image 
        +'" /><div class="sidebar-title-price-container"><span class="name"><p class="name-text">' +incoming[k].product_title 
        +'</p></span>'+ angleHtml + projectionHtml + wallwidthHtml + faceSizeHtml +'<div style="margin-top: -10px; margin-bottom: 10px;">'+ formatMoney(price) 
        +'<span class="unitPrice"> x '+ incoming[k].quantity
        +'</span></div></div></a><span class="close-btn" js-preworn-close-modal=""><svg qty="'+incoming[k].quantity+'" vid="'+ incoming[k].key +
        '"class="remove-item-sidebar" width="25" viewBox="0 0 10 10"><path qty="'+incoming[k].quantity+'" vid="'+ incoming[k].key +'" d="M9.677 8.118a1.102 1.102 0 11-1.559 1.56L5 6.558 1.882 9.677a1.102 1.102 0 11-1.56-1.559L3.442 5 .323 1.882A1.102 1.102 0 111.882.322L5 3.442 8.118.323a1.102 1.102 0 111.56 1.559L6.558 5l3.118 3.118z" fill="red" fill-rule="nonzero"></path></svg></span></div>';
    
        cartdiv.appendChild(cartitemlink);
    }
    if(document.getElementsByClassName('cart-count-bubble').length == 0)
      {
          var cartcountdiv  = document.createElement('div');
          cartcountdiv.classList.add("cart-count-bubble");
          cartcountdiv.innerHTML ='<span aria-hidden="true"></span><span class="visually-hidden"></span>';
          
          document.getElementById("cart-icon-bubble").appendChild(cartcountdiv);
      }
      jQuery.getJSON('/cart.js', function (cart, textStatus) 
      {
          //the cart info is in the callback. the item_count is available as part of the callback
          //below I set my cartcount div with the current cart item_count
          var carttext="("+cart.item_count +")";
          jQuery(".cart-count-bubble").text(carttext);
          jQuery(".count-cart-sidebar").text(carttext);
      });  
  }
}

async function cartFixingOnAdd()
{

  var iLoad = 0;
  try 
  {
    $.ajax({
      url: "https://rocking-rhino-dev.myshopify.com/api/2025-01/graphql.json",
      contentType: "application/json",
      type:'POST',
      async : false,
      headers:{
          "X-Shopify-Storefront-Access-Token": token,
          "Content-Type": "application/json"
      },
      data: JSON.stringify({
      query:`query
      {
          cart(id: "gid://shopify/Cart/${globalToken}") 
          {
          lines(first:250) {
            edges {
              node {
                id
                quantity
                merchandise {
                  ... on ProductVariant {
                    id
                    product
                    {
                      tags
                    }
                  }
                }
              }
            }
          }
        }
      }`
      }),
      }).done(async function (response) 
      {  
        cartFixings = response.data.cart.lines.edges;
        var Score = 
        {
          bgfix:0,
          rivet:0,
          butyl:0,
          silicone:0,
          fb:0,
          pipeclip:0
        };

        var div = document.getElementById('fixingsParentContainer');
        div.style.display = "flex";
        //cartFixings =[];
    
        console.log("Here is null fixing error this needs a value");
        
        for (let index = 0; index < cartFixings.length; index++) 
        {
          var cartItemTags = cartFixings[index].node.merchandise.product.tags;
          var iQty = cartFixings[index].node.quantity;
    
          console.log(cartItemTags);
          for (let k = 0; k < cartItemTags.length; k++) 
          {
            var cartTag = cartItemTags[k];
            var tagValueArray = cartTag.split("_");
    
            if(tagValueArray[0] == "bgfix")
            {
              //tagValueArray[1] is the value
              var iValue =  parseInt(tagValueArray[1]);
              iValue = iValue*iQty;
              Score.bgfix = Score.bgfix + iValue;
            }
            if(tagValueArray[0] == "rivet")
            {
              var iValue =  parseInt(tagValueArray[1]);
              iValue = iValue*iQty;
              Score.rivet = Score.rivet + iValue;
            }
            if(tagValueArray[0] == "butyl")
            {
              var iValue =  parseInt(tagValueArray[1]);
              iValue = iValue*iQty;
              Score.butyl = Score.butyl + iValue;
            }
            if(tagValueArray[0] == "silicone")
            {
              var iValue =  parseInt(tagValueArray[1]);
              iValue = iValue*iQty;
              Score.silicone = Score.silicone + iValue;
            }
            if(tagValueArray[0] == "fb")
            {
              var iValue =  parseInt(tagValueArray[1]);
              iValue = iValue*iQty;
              Score.fb = Score.fb + iValue;
            }
            if(tagValueArray[0] == "pipeclip")
            {
              var iValue =  parseInt(tagValueArray[1]);
              iValue = iValue*iQty;
              Score.pipeclip = Score.pipeclip + iValue;
            }
          }
        }     

        try 
        {
          $.ajax({
            url: "https://rocking-rhino-dev.myshopify.com/api/2025-01/graphql.json",
            contentType: "application/json",
            type:'POST',
            async : false,
            headers:{
                "X-Shopify-Storefront-Access-Token": token,
                "Content-Type": "application/json"
            },
            data: JSON.stringify({
            query:`query
            {
              product(id: "gid://shopify/Product/9504787366230") 
              {
                tags
                title
                variants(first: 1)
                {
                  nodes
                  {
                    price{
                      amount
                    }
                  }
                }
                media(first: 1)
                {
                edges {
                    node {
                      ... on MediaImage {
                        image {
                          url
                        }
                      }
                    }}
                  }
              }
            }`
            }),
            }).done(function (response) 
            {
              const tags = response.data.product.tags;
              const substr = 'fb_';
              const subArr = tags.filter(str => str.includes(substr));
      
              var tagValueArray = subArr[0].split("_");
      
              var iValuefb = tagValueArray[1];
              iValuefb =  parseInt(tagValueArray[1]);
      
              console.log(iValuefb);
              console.log(Score.fb);
              
              var n = 0;
      
              var iCounterfb = Score.fb;
              if(iCounterfb <= 0)
              {
      
              }
              else
              {
                do 
                {
                  iCounterfb = iCounterfb + iValuefb;
                  if(iCounterfb <= 0)
                  {
                    n++;
                    break;
                  }
                  else
                  {
                    n++
                  }
                } 
                while (true)
              }
      
              // n is the count or these fixings
              iLoad = iLoad + n;

            });
        } 
        catch (error) 
        {
          console.log(error);
        }
    
        try 
        {
          $.ajax({
            url: "https://rocking-rhino-dev.myshopify.com/api/2025-01/graphql.json",
            contentType: "application/json",
            type:'POST',
            async : false,
            headers:{
                "X-Shopify-Storefront-Access-Token": token,
                "Content-Type": "application/json"
            },
            data: JSON.stringify({
            query:`query
            {
              product(id: "gid://shopify/Product/9504235356502") 
              {
                tags
                title
                variants(first: 1)
                {
                  nodes
                  {
                    price{
                      amount
                    }
                  }
                }
                media(first: 1)
                {
                edges {
                    node {
                      ... on MediaImage {
                        image {
                          url
                        }
                      }
                    }}
                  }
              }
            }`
          }),
          }).done(function (response) 
          {
          
            const tags = response.data.product.tags;
            const substr = 'rivet_';
            const subArr = tags.filter(str => str.includes(substr));
    
            var tagValueArray = subArr[0].split("_");
    
            var iValue = tagValueArray[1];
            iValue =  parseInt(tagValueArray[1]);
    
            let i = 0;
    
            var iCounter = Score.rivet;
    
            if(iCounter <= 0)
            {
    
            }
            else
            {
              do 
              {
                iCounter = iCounter + iValue;
                if(iCounter <= 0)
                {
                  i++;
                  break;
                }
                else
                {
                  i++
                }
              } 
              while (true)
            }
            iLoad = iLoad + i;
            // i is total to be added
  
          });
        } 
        catch (error) 
        {
          
        }
        var iScorePipe = Score.pipeclip

        var iScoreButyl = Math.ceil(Score.butyl);
        var iScoreSilicone = Math.ceil(Score.silicone);

        var fitingAddScore = iScorePipe + iScoreButyl + iScoreSilicone;
        // n is the count or these fixings
        iLoad = iLoad +fitingAddScore;
        var fixingCount = document.getElementById("fixingCount");
        var fixingCount = document.getElementById("fixingCount");
        if(iLoad == 0)
        {
          fixingCount.style.display = 'none';
        }
        else
        {
          fixingCount.style.display = 'flex';
          fixingCount.innerText = iLoad; 
        }
      });
  } 
  catch (error) 
  {
    console.log(error);
  }
}


document.addEventListener("input", async (event) => {

  if (event.target.matches('input.fixingCount')) 
  {
    console.log("Value changed:", event.target.value);
    strVid = event.target.getAttribute("vid");

    var strImgURL = event.target.parentElement.parentElement.parentElement.children[0].children[0].src;
    var strTitle = event.target.parentElement.parentElement.parentElement.children[0].children[1].children[0];
    var strSku = event.target.parentElement.parentElement.parentElement.children[0].children[1].children[1];

    console.log(globalToken);
    if (globalToken == "") 
    {
      await getCart();
    }
    iTextCount = parseInt(event.target.parentElement.children[1].value);
    var temp = strVid.split("gid://shopify/ProductVariant/"); 
    strVid = temp[1];

    addedProductName.innerText = strTitle.innerText
    addedProductSku.innerText = strSku.innerText
    addedProductQty.innerText = "X " +iTextCount
    addedImg.src = strImgURL

    if(milled.checked == true)
    {
        strNote = "Mill";
    }
    else
    {
        try
        {
          var activeItem = document.getElementsByClassName("activeFilterItem");
          strNote = activeItem[0].attributes.value.nodeValue;
          var strRalNote = activeItem[0].children[0].children[1].children[0].children[0].innerHTML
          strNote = strRalNote;
          if(marine.checked == true)
          {
            strNote = strNote + " Marine" 
          }

        }
        catch(e)
        {
          var preGrid = document.getElementById("activeColourDisplay");
          strNote = preGrid.className;
          if(strNote == "Mill" && milled.checked == false)
          {
              strNote ="";
          }
          if(marine.checked == true)
          {
            strNote = strNote + " Marine" 
          }
          else
          {
            strNote = strNote.replace(" Marine", "");
            strNote = strNote.replace(" MARINE", "");
          }
          if(strNote.includes("MARINE Marine"))
          {
            strNote = strNote.replace("MARINE Marine", "MARINE");

          }
          if(strNote.includes(" Marine Marine"))
          {
            strNote = strNote.replace("Marine Marine", "MARINE");
          }
        }
      
    }
    if(strNote == "none" || strNote == "None" || strNote == " Marine" || strNote == "Marine" || strNote == "none Marine" || strNote == "None Marine")
    {
      strNote = "";
    }
    if(strNote.length > 1)
    {
      if(iTextCount > 0)
      {
        //GHEHG awaithere
        await graphCart(strVid, iTextCount, 1);
        //removerherge4
      }
      else
      {
        var modal = document.getElementById("myModal");

        var alertContent = document.getElementById("alertContent");
        alertContent.innerHTML = "<h3>Alert</h3><p>Please Add Quantity</p>"
        window.onclick = function(event) 
        {
          if (event.target == modal) {
            modal.style.display = "none";
          }
        }
        var span = document.getElementsByClassName("close")[0];
        modal.style.display = "block";

        span.onclick = function() 
        {
          modal.style.display = "none";
        }
      }
    }
    else
    {
        var modal = document.getElementById("myModal");
        var alertContent = document.getElementById("alertContent");
        alertContent.innerHTML = "<h3>Alert</h3><p>Please Select A finish</p>"
        window.onclick = function(event) 
        {
          if (event.target == modal) {
            modal.style.display = "none";
          }
        }
        var span = document.getElementsByClassName("close")[0];
        modal.style.display = "block";

        span.onclick = function() 
        {
          modal.style.display = "none";
        }
    }



  }
});


async function setCartCount() {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: "https://rocking-rhino-dev.myshopify.com/api/2025-01/graphql.json",
      contentType: "application/json",
      type: "POST",
      async: true,
      headers: {
        "X-Shopify-Storefront-Access-Token": storefronttoken,
        "Content-Type": "application/json"
      },
      data: JSON.stringify({
        query: `query {
          cart(id: "gid://shopify/Cart/${globalToken}") {
            lines(first: 250) {
              edges {
                node {
                  quantity
                  merchandise {
                    ... on ProductVariant {
                      product {
                        tags
                      }
                    }
                  }
                }
              }
            }
          }
        }`
      }),
      success: function(response) {
        let nonFixingCartSize = 0;
        const lines = response?.data?.cart?.lines?.edges || [];

        for (const edge of lines) {
          const qty = edge.node.quantity || 0;
          const tags = edge.node.merchandise?.product?.tags || [];
          const isFixingSundries = tags.includes("colourless");

          if (!isFixingSundries) {
            nonFixingCartSize += qty;
          }
        }

        resolve(nonFixingCartSize);
      },
      error: function(err) {
        reject(err);
      }
    });
  });
}
